/** @typedef {'kg' | 'lb'} WeightUnit */
/** @typedef {'cm' | 'ftin'} HeightUnit */

/**
 * @param {string} pathname
 * @param {{ weightUnit?: WeightUnit, heightUnit?: HeightUnit, weightKg?: number, heightCm?: number }} state
 */
export function buildBmiCalculatorSharePath(pathname, state) {
    const params = new URLSearchParams();
    if (state.weightUnit === 'lb') params.set('wu', 'lb');
    if (state.heightUnit === 'ftin') params.set('hu', 'ft');
    if (state.weightKg && state.weightKg > 0) {
        params.set('w', String(Math.round(state.weightKg * 10) / 10));
    }
    if (state.heightCm && state.heightCm > 0) {
        params.set('h', String(Math.round(state.heightCm * 10) / 10));
    }
    const qs = params.toString();
    return qs ? `${pathname}?${qs}` : pathname;
}

/**
 * @param {string} origin
 * @param {string} pathname
 * @param {Parameters<typeof buildBmiCalculatorSharePath>[1]} state
 */
export function buildBmiCalculatorShareUrl(origin, pathname, state) {
    return `${origin}${buildBmiCalculatorSharePath(pathname, state)}`;
}

/**
 * @param {URLSearchParams | string} input
 * @returns {{ weightKg: number | null, heightCm: number | null, weightUnit: WeightUnit, heightUnit: HeightUnit }}
 */
export function parseBmiCalculatorShareParams(input) {
    const params = typeof input === 'string' ? new URLSearchParams(input) : input;
    const wRaw = params.get('w');
    const hRaw = params.get('h');
    const uRaw = params.get('u');
    const wuRaw = params.get('wu');
    const huRaw = params.get('hu');

    const weightKg = wRaw && Number(wRaw) > 0 ? Number(wRaw) : null;
    const heightCm = hRaw && Number(hRaw) > 0 ? Number(hRaw) : null;

    let weightUnit = /** @type {WeightUnit} */ (wuRaw === 'lb' ? 'lb' : 'kg');
    let heightUnit = /** @type {HeightUnit} */ (huRaw === 'ft' ? 'ftin' : 'cm');

    // Legacy: u=i meant full imperial (lb + ft/in)
    if (uRaw === 'i') {
        weightUnit = 'lb';
        heightUnit = 'ftin';
    }

    return { weightKg, heightCm, weightUnit, heightUnit };
}
